(function () {

    'use strict';

    angular.module('iplusjs.validationMessage', [
        'ngMessages',
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.format',
        'iplusjs.utils.bindHtmlCompile'
    ])
        .component('iplusjsValidationMessage', {
            bindings: {
                control: '<ivmControl',
                placeholder: '<ivmPlaceholder',
                name: '@ivmName',
                scope: '<ivmScope',
                options: '<?ivmOptions'
            },
            templateUrl: 'common/validationmessage/validationMessage.html',
            controller: ValidationMessageController,
            controllerAs: 'validationMessageVm'
        })
        .service('ValidationMessageService', ValidationMessageService);

    ValidationMessageController.$inject = [
        '$element',
        'lodash',
        'ValidationMessageService',
        'FormatUtilsService'
    ];
    function ValidationMessageController($element, _, ValidationMessageService, FormatUtilsService) {
        var vm = this,
            ACTIVE_CLASS = 'active';

        vm.validationMessages = [];
        vm.$onInit = onInit;
        vm.$doCheck = doCheck;
        vm.replacePlaceholders = replacePlaceholders;
        vm.isValidationMessageSichtbar = isValidationMessageSichtbar;
        vm.isValidationMessagesRequiredSichtbar = isValidationMessagesRequiredSichtbar;

        function activate() {
            vm.validationOptions = vm.options || {};

            ValidationMessageService.get(vm.name).then(function (messages) {
                vm.validationMessages = messages;
            }).catch(function () {
                vm.validationMessages = {};
            });
        }

        function onInit() {
            activate();
        }

        function doCheck() {
            if ($element[0].getElementsByClassName('ng-active').length) {
                $element.addClass(ACTIVE_CLASS);
            } else {
                $element.removeClass(ACTIVE_CLASS);
            }
        }

        function replacePlaceholders(message, type) {
            var msg = message,
                regexViewModelValue = /\{(\$(?:viewValue|modelValue))\}/,
                match;

            if (!msg) {
                return '';
            }

            match = msg.match(regexViewModelValue) || [];

            if (match.length) {
                msg = msg.replace(match[0], vm.control[match[1]]);
            }

            if (vm.placeholder && vm.placeholder[type]) {
                msg = FormatUtilsService.replace.apply(null, _.flatten([message, vm.placeholder[type]]));
            }

            return msg;
        }
        function isValidationMessageSichtbar() {
            var control = vm.control || {};

            return (
                (
                    !!_.get(vm.validationOptions, 'showMessageOnValidate') ||
                    (
                        !!_.get(vm.validationOptions, 'showMessageOnSubmitted') &&
                        control.$submitted === true

                    ) ||
                    control.$touched ||
                    control.isSubmitted
                ) &&
                !control.$pending
            );
        }
        function isValidationMessagesRequiredSichtbar() {
            return (
                !!_.get(vm.validationOptions, 'showRequiredMessageOnValidate')
            );
        }
    }

    ValidationMessageService.$inject = [
        '$http',
        '$log',
        'lodash',
        'AppConfig'
    ];

    function ValidationMessageService($http, $log, _, AppConfig) {
        var that = this;

        that.get = get;
        function get(name) {
            return $http.get((AppConfig.APP.releaseDir ? AppConfig.APP.releaseDir + '/' : '') + 'data/validationMessages.json', {
                cache: true
            }).then(function (response) {
                $log.debug('iplusjsValidationMessage activate SUCCESS', name, response.data);
                return _.get(response.data, name, {}).validations || {};

            }).catch(function (error) {
                $log.debug('iplusjsValidationMessage activate FAILURE', error);
                return {};
            });
        }
    }

})();
